module.exports = __webpack_public_path__ + "static/media/Mingl_Icon_Blue.5772a9b9.png";